import { useCallback, useEffect } from 'react';
import { FieldValues, Path, PathValue, UseFormReturn } from 'react-hook-form';

export function useAutosaveAndRestoreForm<T extends FieldValues = FieldValues>(
  key: string,
  form: UseFormReturn<T>,
  options: { active: boolean }
) {
  useEffect(() => {
    if (!options.active) {
      return;
    }

    const saved = sessionStorage.getItem(key);

    if (saved) {
      const data = JSON.parse(saved);

      Object.entries(data).forEach(([key, value]) => {
        form.setValue(key as Path<T>, value as PathValue<T, Path<T>>);
      });
    }

    const intervalId = setInterval(() => {
      sessionStorage.setItem(key, JSON.stringify(form.getValues()));
    }, 1000);

    return () => {
      clearTimeout(intervalId);
    };
  }, [form, key, options.active]);

  const clear = useCallback(() => {
    if (!options.active) {
      return;
    }

    sessionStorage.removeItem(key);
  }, [key, options.active]);

  return { clear };
}
